import { render, staticRenderFns } from "./UploadSingleImage.vue?vue&type=template&id=344e3a98"
import script from "./UploadSingleImage.vue?vue&type=script&lang=js"
export * from "./UploadSingleImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/050/050admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('344e3a98')) {
      api.createRecord('344e3a98', component.options)
    } else {
      api.reload('344e3a98', component.options)
    }
    module.hot.accept("./UploadSingleImage.vue?vue&type=template&id=344e3a98", function () {
      api.rerender('344e3a98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Upload/UploadSingleImage.vue"
export default component.exports